<template>
<div container--fluid>
    <v-layout>
        <RefereeAvailModule></RefereeAvailModule>
    </v-layout>
</div>
</template>

<script>
import RefereeAvailModule from '@modules/referee/availability.vue';

export default {
    name: 'refereeAvail',
    components: {
        RefereeAvailModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
